import React, { useState, useEffect } from 'react';
import './programassociales.css';

const PBPA = () => {
   
  const [expandida, setExpandida] = useState(null);
    
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleImagen = (id) => {
    setExpandida(expandida === id ? null : id);
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3 
            className='title'
            style={{ 
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Convocatoria<br />
            Bienestar Para Personas Artesanas<br />
            Ejercicio Fiscal 2026
          </h3>

            <br />

             <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Consulta la convocatoria
          </h5>

          {/* 🔥 BOTÓN PRINCIPAL (PRIMER RENGLÓN) */}
          <div className="botones">
            <a href="/Convocatorias/CPBPA" className="btn-vino">
              Descargar
            </a>
          </div>

            <br />

             <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Obtén los formatos
          </h5>

          {/* 🔥 BOTONES SECUNDARIOS (SEGUNDO RENGLÓN) */}
          <div className="botones">
            <a href="/Formatos/FUPS" className="btn-vino">FUPS</a>
            <a href="/Formatos/SOA" className="btn-vino">Solicitud</a>
            <a href="/Formatos/CCOMP" className="btn-vino">Carta</a>
            <a href="/Formatos/CCDP" className="btn-vino">Consentimiento</a>
          </div>
              <br />
          <h5 
            className='hero'
            style={{ 
              color: 'white',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Resumen
          </h5>

          {/* 🔥 IMAGEN */}
          <div className="hero">
            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PBPA_2026.png"
                alt="PBPA"
                className={expandida === 1 ? "img expandida" : "img"}
                onClick={() => toggleImagen(1)}
              />
            </div>
          </div>

          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default PBPA;